import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoIcon, Modal } from '@itsrever/design-system'
import { StatusPill } from './primitives'
import { SizingStatus } from '@/domain/sizing'

const STATUSES: SizingStatus[] = [
  'WORKING',
  'COLLECTING_DATA',
  'NO_CLEAR_EFFECT',
  'REDIAGNOSIS',
  'RETIRED'
]

const STATUS_COPY: Record<SizingStatus, string> = {
  WORKING: 'sizing.info.status_working',
  COLLECTING_DATA: 'sizing.info.status_collecting',
  NO_CLEAR_EFFECT: 'sizing.info.status_no_effect',
  REDIAGNOSIS: 'sizing.info.status_rediagnosis',
  RETIRED: 'sizing.info.status_retired'
}

function Section({ title, children }: { title: string; children: string }) {
  return (
    <section className="mb-4 last:mb-0">
      <h4 className="mb-1 text-sm font-semibold text-neutral-900">{title}</h4>
      <p className="text-sm leading-5 text-neutral-600">{children}</p>
    </section>
  )
}

export function SizingInfoButton() {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        aria-label={t('sizing.info.title')}
        onClick={() => setIsOpen(true)}
        className="flex cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 opacity-40 transition-opacity hover:opacity-100"
      >
        <InfoIcon scale={0.7} />
      </button>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        closeButton={true}
      >
        <div className="max-h-[70vh] w-[min(34rem,80vw)] overflow-y-auto p-2">
          <h3 className="mb-1 text-lg font-medium text-neutral-900">
            {t('sizing.info.title')}
          </h3>
          <p className="mb-4 text-sm text-neutral-600">
            {t('sizing.info.intro')}
          </p>

          <Section title={t('sizing.info.cycle_title')}>
            {t('sizing.info.cycle_body')}
          </Section>
          <Section title={t('sizing.info.model_title')}>
            {t('sizing.info.model_body')}
          </Section>
          <Section title={t('sizing.info.measure_title')}>
            {t('sizing.info.measure_body')}
          </Section>

          <h4 className="mb-2 text-sm font-semibold text-neutral-900">
            {t('sizing.info.status_title')}
          </h4>
          {STATUSES.map((status) => (
            <div
              key={status}
              className="grid grid-cols-[8.5rem_1fr] items-start gap-3 border-0 border-b border-solid border-neutral-200 py-2 last:border-b-0"
            >
              <StatusPill status={status} />
              <p className="text-sm leading-5 text-neutral-600">
                {t(STATUS_COPY[status])}
              </p>
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}
